// extracted by mini-css-extract-plugin
export default {"root":"RequestApproveForm_root__eojbe","switch":"RequestApproveForm_switch__Bwjau"};